import { readonly, ref } from "vue";

const classicThemeActive = ref(false);
export const isClassicThemeActive = readonly(classicThemeActive);

export const CLASSIC_THEME_CLASS = "classic-theme";

export const classicThemeRouteMeta = {
  classicTheme: true,
} as const;

export function syncClassicThemeClass(enabled: boolean) {
  classicThemeActive.value = enabled;
  document.documentElement.classList.toggle(CLASSIC_THEME_CLASS, enabled);
  document.body.classList.toggle(CLASSIC_THEME_CLASS, enabled);
}

export function syncClassicThemeForInitialPath(
  pathname: string,
  resolve: (pathname: string) => { meta: { classicTheme?: unknown } },
) {
  const isWorkspaceRedirect = pathname === "/u" || pathname === "/u/";
  syncClassicThemeClass(
    isWorkspaceRedirect || resolve(pathname).meta.classicTheme === true,
  );
}
